import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ScreenMirroringLaptopIcon } from '@getgo/chameleon-icons/react';
import { Alert } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import ChatMessageEvent from "../ChatMessageEvent";
import TextTime from "../TextTime";
import { useTranslation } from 'react-i18next';
import { MessageDirection, } from "../../../state/conversation/types";
import classes from './CobrowseStartedEvent.module.scss';
const CobrowseStartedEvent = ({ fullWidth, compact, color, agents, customAvatarIconUrl, genericAvatarIconId, entry, currentUser, cobrowse, truncate, }) => {
    const { t } = useTranslation();
    const messageEvent = {
        id: cobrowse.id,
        direction: MessageDirection.OUTBOUND,
        conversationId: cobrowse.conversationId,
        from: Object.assign({}, cobrowse.performedBy),
        createdAt: cobrowse.createdAt,
        body: cobrowse.invitationMessage,
    };
    const getCCResolveBaseURL = () => {
        switch (window.environment) {
            case 'prod':
                return '//app.goto.com/cc-resolve';
            case 'staging':
                return '//app.staging.gtc.goto.com/cc-resolve';
            case 'dev':
            default:
                return '//app.dev.gtc.goto.com/cc-resolve';
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ role: "listitem", className: classNames(classes.cobrowseStartedEvent, {
                    [classes.cobrowseStartedEvent_fullWidth]: fullWidth,
                    [classes.cobrowseStartedEvent_compact]: compact,
                }) }, { children: _jsx(Alert, Object.assign({ icon: _jsx(ScreenMirroringLaptopIcon, {}, void 0), variant: "info" }, { children: _jsx(TextTime, { text: _jsxs(_Fragment, { children: [_jsx("span", { children: t('A co-browsing session started.') }, void 0), "\u00A0", _jsx("a", Object.assign({ href: `${getCCResolveBaseURL()}/session/${cobrowse.sessionPin}?${new URLSearchParams({
                                        serviceUrl: cobrowse.serviceUrl,
                                        accountKey: cobrowse.accountKey,
                                    }).toString()}`, target: "_blank", rel: "noreferrer" }, { children: t('Join here') }), void 0)] }, void 0), time: cobrowse.createdAt, truncate: truncate }, void 0) }), void 0) }), void 0), _jsx(ChatMessageEvent, { compact: compact, color: color, agents: agents, customAvatarIconUrl: customAvatarIconUrl, genericAvatarIconId: genericAvatarIconId, fullWidth: fullWidth, entry: entry, conversationId: cobrowse.conversationId, participant: cobrowse.performedBy, message: messageEvent, currentUser: currentUser }, void 0)] }, void 0));
};
export default CobrowseStartedEvent;
//# sourceMappingURL=index.js.map